import { Status } from 'generated/graphql';
import { UserType } from 'v2/core/entities/user';
import { useGetUser } from 'v2/core/services/user';

interface UseIsArtefactEditableOptions {
  editToken: string | undefined;
  status: Status | undefined; // It can undefined, for ex. DashboardListItem type used in Dashboard templates
}

export const useIsArtefactEditable = ({
  editToken,
  status,
}: UseIsArtefactEditableOptions) => {
  const user = useGetUser();

  if (user.type === UserType.SuperManager) {
    return true;
  }

  const isUnarchived = status ? status === Status.Unarchived : true;

  return !!editToken && isUnarchived;
};
